import React from 'react';
import s from './Footer.module.scss';

import logo from './assets/logoIconoR.png';

//Material UI
import {
  Grid,
  Link
} from '@mui/material';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';

const options = [
  { name: 'Sobre nosotros', href: '#about' },
  { name: 'Nuestros clientes', href: '#CustomerCarousel' },
  { name: 'Productos destacados', href: '#ProductGrid' },
];

const Footer = () => {

  return (
    <>
      <Grid item xs={12} spacing={2} container className={s.container}>
        <Grid
          item
          container
          lg={5}
          md={12}
          xs={12}
          sx={{ justifyContent: 'center' }}
        >
          <Grid
            item
            lg={8}
            xs={12}
            sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
          >
            <h4
              style={{
                fontSize: '1rem',
                color: '#EEEEEE',
                fontWeight: 400,
                textAlign: 'center',
              }}
            >
              EXPERTOS EN SEGURIDAD ELECTRÓNICA
            </h4>
          </Grid>
          <Grid
            item
            lg={3}
            xs={12}
            sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
          >
            <img src={logo} alt="footer-logo" height="140rem" />
          </Grid>
        </Grid>

        <Grid
          item
          container
          lg={7}
          md={12}
          xs={12}
          sx={{ justifyContent: 'center', alignItems: 'center', my: 2 }}
        >
          {options.map((item, index) => (
            <Link
              key={index}
              href={item.href}
              sx={{ textDecoration: 'none' }}
            >
              <p
                style={{
                  fontSize: '0.9rem',
                  color: '#EEEEEE',
                  marginLeft: '2rem',
                  marginRight: '2rem',
                  marginBottom: '18px',
                }}
              >
                {item.name}
              </p>
            </Link>
          ))}
        </Grid>

        <Grid
          item
          xs={12}
          sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mt: -1 }}
        >
          <a
            href="https://www.instagram.com/fustecseguridad/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: 'none' }}
          >
            <InstagramIcon sx={{ fontSize: '1.6rem', color: '#EEEEEE', mr: 1 }} />
          
          </a>
          <a 
            href="https://www.facebook.com/fustecseguridad"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: 'none' }}
          >
            <FacebookIcon sx={{ fontSize: '1.6rem', color: '#EEEEEE' }} />
          </a>
        </Grid>

        <Grid
          item
          xs={12}
          sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
        >
          <p
            style={{
              fontSize: '0.8rem',
              color: '#EEEEEE',
              textAlign: 'center',
            }}
          >
            2026 Fustec seguridad ®. Todos los derechos reservados
          </p>
        </Grid>

        {/* Link que abre el modal de Términos y condiciones */}
        <Grid
          item
          xs={12}
          sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mb: 3 }}
        >
          <a
            href="/terminos-y-condiciones"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: 'none' }}
          >
            <p style={{ fontSize: '0.8rem', color: '#EEEEEE', textAlign: 'center' }}>
              Términos y condiciones ↗
            </p>
          </a>

        </Grid>
      </Grid>

    </>
  );
};

export default Footer;
